const state = () => {
  return {
    filters: [
      {
        icon: "MapPinIcon",
        title: "State/Location",
        model: "state",
        endpoint: "states-params"
      },
      {
        icon: "BriefcaseIcon",
        title: "Agency",
        model: "agency",
        endpoint: "agencies-params"
      },
      {
        icon: "ArchiveIcon",
        title: "Crime/Offence",
        model: "case_type",
        endpoint: "case-types-params"
      },
      {
        icon: "PenToolIcon",
        title: "Court",
        model: "court",
        endpoint: "courts-params"
      },
      {
        icon: "UserIcon",
        title: "Judge",
        model: "judge",
        endpoint: "judges-params"
      },
      {
        icon: "ClockIcon",
        title: "Duration",
        model: "duration",
        endpoint: "duration-params"
      },
      {
        icon: "BarChartIcon",
        title: "Status",
        model: "status",
        endpoint: "statuses-params"
      },
      {
        icon: "NavigationIcon",
        title: "Stages",
        model: "stage",
        endpoint: "stages-params"
      },
      {
        icon: "GridIcon",
        title: "Sector",
        model: "sector",
        endpoint: "sector-params"
      }
    ],
    selectedFilters: {},
    count: 0
  };
};

// getters
const getters = {
  filters: state => state.filters,
  getSelectedFilters: state => state.selectedFilters,
  getCount: state => state.count
};

// actions
const actions = {
  changeSelectedFilters(context, payload) {
    context.commit("setSelectedFilters", payload);
    context.commit("increaseCount");
  },
  changeCount(context) {
    context.commit("increaseCount");
  }
};

// mutations
const mutations = {
  setSelectedFilters(state, payload) {
    state.selectedFilters = payload;
  },
  increaseCount(state) {
    state.count = state.count + 1;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
